/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import Products from "views/siif/Products.js"
import AccountMovements from "views/siif/AccountMovements.js"
import LoanMovements from "views/siif/LoanMovements.js"
import Pays from "views/siif/Pays.js"
import Transfers from "views/siif/Transfers.js"
import MassiveTransfers from "views/siif/MassiveTransfers.js"
import Utilizations from "views/siif/Utilizations.js"
import Puckets from "views/siif/Puckets.js"
import Contacts from "views/siif/Contacts.js"
import AddContact from "views/siif/AddContact.js"
import ExtractsAndCertificates from "views/siif/ExtractsAndCertificates.js"
import Security from "views/siif/Security.js"
import Profiles from "views/siif/perfiles.js"
import Request from "views/siif/Request.js"

import HomePage from "views/siif/HomePage.js"
import Cambio from 'views/examples/cambioCotraseña.js'
import Proyeccion from 'views/siif/Proyeccion.js'
import CdtMovements from "views/siif/CdtMovements.js"
import icon_home from  'assets/img/icons/Icono-Inicio-Gris.png'
import icon_pays from  'assets/img/icons/Icono-Pagos-Gris.png'
import icon_transfer from  'assets/img/icons/Icono-Transferencia-Gris.png'
import icon_massivetransfer from  'assets/img/icons/Icono-Transfrencias-Multiples-Gris.png'
import icon_utilizations from  'assets/img/icons/Icono-Utilizaciones-Gris.png'
import icon_homeA from  'assets/img/icons/Icono-Inicio-Verde.png'
import icon_paysA from  'assets/img/icons/Icono-Pagos-Rojo.png'
import icon_transferA from  'assets/img/icons/Icono-Transferencia-Rojo.png'
import icon_massivetransferA from  'assets/img/icons/Icono-Transfrencias-Multiples-Verde.png'
import icon_utilizationsA from  'assets/img/icons/Icono-Utilizaciones-Rojo.png'
import icon_circulomas from 'assets/img/icons/circulo-mas.png'
import icon_Administras_usuarios from 'assets/img/icons/Icono-Administrar-Usuarios-Gris.png'
import { stubFalse } from "lodash"
import UsuariosExternos from "views/siif/UsuariosExternos"
import RegistroUsuarioExterno from "views/siif/RegistroUsuarioExterno"
import AuxiliarRegistro from "views/siif/AuxiliarRegistro"
import cambioCotraseña from "views/examples/cambioCotraseña"
//import icon_Administras_usuariosA from 'assets/img/icons/Icono-Administrar-Usuarios-Rojo.png'
import { CreateRequestCredit } from "views/siif/CreateRequestCredit.js"
import { CreateViewAccount } from "views/siif/CreateViewAccount"
import ConfirmacionPago from "views/siif/PaymentOptions/ConfirmacionPago"



var routes = [
  {
    path: "/home",
    name: "Inicio",
    icon: "far fa-credit-card text-primary",
    icon: icon_home,
    icon_active: icon_homeA,
    linkActive: false,
    component: HomePage,
    layout: "/admin",
    invisible: false,
    profile: "consulta, transaccion"
  },
  {
    path: "/product",
    name: "Crea tu producto",
    icon: "far fa-credit-card text-primary",
    icon: icon_circulomas,
    layout: "/admin",
    invisible: false,
    profile: "consulta, transaccion",
    submenu:[
        {
          name: "Solicitud Credito",
          path: "/solicitud-credito",
          component: CreateRequestCredit,
        },
        {
          name: "Cuenta vista",
          path: "/cuenta-vista",
          component: CreateViewAccount,
        }
    ]
  },
  {
    path: "/products",
    name: "Productos",
    icon: "far fa-credit-card text-primary",
    component: Products,
    layout: "/admin",
    invisible: true,
    profile: "consulta, transaccion"
  },
  {
    path: "/AuxiliarRegistro",
    name: "AuxiliarRegistro",
    icon: "far fa-credit-card text-primary",
    component: AuxiliarRegistro,
    layout: "/auth",
    invisible: true,
    profile: "consulta, transaccion"
  },
  {
    path: "/UsuariosExternos",
    name: "Usuarios Externos",
    icon: "far fa-credit-card text-primary",
    component: UsuariosExternos,
    layout: "/auth",
    invisible: true,
    profile: "consulta, transaccion"
  },
  {
    path: "/cambioCotraseña",
    name: "cambio contraseña",
    icon: "far fa-credit-card text-primary",
    component: cambioCotraseña,
    layout: "/auth",
    invisible: true,
    profile: "consulta, transaccion"
  },
  {
    path: "/RegistroUsuarioExterno",
    name: "Registo Usuario Externo",
    icon: "far fa-credit-card text-primary",
    component: RegistroUsuarioExterno,
    layout: "/admin",
    invisible: true,
    profile: "consulta, transaccion"
  },
  {
    path: "/product/account-movements",
    name: "Movimientos",
    icon: "ni ni-bag-17 text-primary",
    component: AccountMovements,
    layout: "/admin",
    invisible: true,
    profile: "consulta, transaccion"
  },
  {
    path: "/product/cdt-movements",
    name: "Movimientos",
    icon: "ni ni-bag-17 text-primary",
    component: CdtMovements,
    layout: "/admin",
    invisible: true,
    profile: "consulta, transaccion"
  },
  {
    path: "/product/loan-movements",
    name: "Movimientos",
    icon: "ni ni-bag-17 text-primary",
    component: LoanMovements,
    layout: "/admin",
    invisible: true,
    profile: "consulta, transaccion"
  },
  {
    path: "/pays",
    name: "Pagos",
    //icon: "fas fa-money-bill-wave text-primary",
    icon:icon_pays,
    icon_active: icon_paysA,
    linkActive: false,
    component: Pays,
    layout: "/admin",
    invisible: true,
    profile: "transaccion"
  },
  {
    path: "/transfers",
    name: "Transferencias",
    //icon: "fas fa-exchange-alt text-primary",
    icon: icon_transfer,
    icon_active: icon_transferA,
    linkActive: false,
    component: Transfers,
    layout: "/admin",
    invisible: true,
    profile: "transaccion"
  },
  {
    path: "/massive-transfers",
    name: "Transacciones Masivas",
    //icon: "fas fa-exchange-alt text-primary",
    icon :icon_massivetransfer,
    icon_active :icon_massivetransferA,
    linkActive: false,
    component: MassiveTransfers,
    layout: "/admin",
    invisible: false,
    profile: "transaccion"
  },
  {
    path: "/utilizations",
    name: "Utilizaciones",
    //icon: "fas fa-money-check-alt text-primary",
    icon : icon_utilizations,
    icon_active : icon_utilizationsA,
    linkActive: false,
    component: Utilizations,
    layout: "/admin",
    invisible: true,
    profile: "transaccion"
  },
  {
    path: "/puckets",
    name: "Bolsillos",
    icon: "fas fa-file-invoice-dollar text-primary",
    component: Puckets,
    layout: "/admin",
    invisible: true,
    profile: ""
  },
  {
    path: "/requests",
    name: "Solicitudes",
    icon: "far fa-question-circle text-primary",
    component: Request,
    layout: "/admin",
    invisible: true,
    profile: ""
  },
  {
    path: "/contacts",
    name: "Mis contactos",
    icon: "",
    component: Contacts,
    layout: "/admin",
    invisible: true,
    profile: "transaccion"
  },
  {
    path: "/contact/addContact",
    name: "Mis contactos",
    icon: "",
    component: AddContact,
    layout: "/admin",
    invisible: true,
    profile: ""
  },
  {
    path: "/certificates",
    name: "Extractos y certificados",
    icon: "",
    component: ExtractsAndCertificates,
    layout: "/admin",
    invisible: true,
    profile: "consulta"
  },
  {
    path: "/security",
    name: "Seguridad",
    icon: "",
    component: Security,
    layout: "/admin",
    invisible: true,
    profile: "transaccion"
  },
  {
    path: "/profiles",
    name: "profiles",
    icon: "",
    component: Profiles,
    layout: "/admin",
    invisible: true,
    profile: ""
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-primary",
    component: Cambio,
    layout: "/auth",
    invisible: true,
    profile: ""
  },
  {
    path: "/CambioContraseña",
    name: "contraseña",
    icon: "ni ni-circle-08 text-primary",
    component: Cambio,
    layout: "/auth",
    invisible: true,
    profile: ""
  },
  {
    path: "/confirmacionpago",
    name: "Confirmacion Pago",
    icon: "ni ni-circle-08 text-primary",
    component: ConfirmacionPago,
    layout: "/auth",
    invisible: true,
    profile: ""
  },
  {
    path: "/Proyeccion",
    name: "Proyeccion",
    icon: "far fa-credit-card text-primary",
    component: Proyeccion,
    layout: "/admin",
    invisible: true,
    profile: "transaccion"
  }
];

export default routes;
